module.exports = __webpack_public_path__ + "img/services-cover.7d6bae38.png";